var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTerminalWindow = function SvgIconTerminalWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.203 3.5c.992 0 1.797.804 1.797 1.797v13.406c0 .992-.805 1.797-1.797 1.797H3.797A1.797 1.797 0 0 1 2 18.703V5.297C2 4.304 2.804 3.5 3.797 3.5zM4 18.5h16v-13H4zM6.719 8.375a1 1 0 0 1 1.323-.216l.083.06 3.75 3a1 1 0 0 1 0 1.562l-3.75 3a1 1 0 0 1-1.25-1.562L9.648 12 6.875 9.781l-.076-.068a1 1 0 0 1-.08-1.338M16.5 14a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2z"
  })));
};
export default SvgIconTerminalWindow;